import { Component, For } from "solid-js";
import { ClassificationType, classificationTypeNames } from "~/mydata";
import { PropsOf } from "./input";
import SelectFormControl from "./SelectFormControl";

export type ItemVatClassification = {
	type: ClassificationType
};
const InvoiceItemVatClassificationSelect: Component<
	{
		itemVatClassifications: string[]
		itemVatClassification?: ItemVatClassification;
		setItemVatClassification(c?: ItemVatClassification): void;
	} & PropsOf<typeof SelectFormControl>
> = (props) => {
	return (
		<SelectFormControl
			errors={props.errors}
			style="text-overflow:ellipsis;"
			name="itemVatClassification"
			onChange={(e) => props.setItemVatClassification({type: e.currentTarget.value as ClassificationType})}
			label="Χαρακτηρισμός φόρου"
			{...props}
		>
			<option
				selected={props.itemVatClassification === undefined}
        value=""
				disabled
      >
				Επιλέξτε...
			</option>
			<For each={props.itemVatClassifications}>{
				(vatClassification) => {
					return (
						<option value={vatClassification}>
							{classificationTypeNames[vatClassification as ClassificationType]}
						</option>
					);
				}
			}</For>
		</SelectFormControl>
	);
};

export default InvoiceItemVatClassificationSelect;